<template>

<div v-if="isAtLargeScreen" class="h-screen p-3">
  <section class="h-full w-full flex space-x-3" >
    <!-- top navigation -->
    <div class="h-full transition-all flex flex-col space-y-2"  :class="[isAsideExpanded ? 'w-3/12' : '', 'w-1/12']">
      <top-navigation :isAsideExpanded="isAsideExpanded" class="h-1/6"  :costumizedUsersData="costumizedUsersData" @toggleUserInfoTab="(toOpen)=>{$refs.userInfo.toggleTab(toOpen,costumizedUsersData,currentUsersData)}" @signOut="signOut" ref="topNavigation"></top-navigation>

      <!-- side navigation -->
      <section class="h-5/6">
        <side-chat-navigation   v-if="hasChatRoom" ref="sideChatNavigation" :usersChatRoom="usersChatRoom" :isAsideExpanded="isAsideExpanded" :currentOpenedChatRoom="currentOpenedChatRoom" :currentUsersData="currentUsersData" :isAtLargeScreen="isAtLargeScreen" :previousOpenedChatId="previousOpenedChatId" :maxChatRooms="maxChatRooms" :isAddingSideChatRoom="isAddingSideChatRoom" :sideChatRoomLimit="sideChatRoomLimit" :chatRoomsId="costumizedUsersData.chatRoomsId"  @errorIcon="(key)=>setChatRoomErrorIcon(key)" @toggleIsAsideExpanded="toggleIsAsideExpanded" @setCurrentChatRoom="(chatRoomId)=>setCurrentChatRoom(chatRoomId)" @createChatRoom="createChatRoom" @bottomScrolled="watchUsersChatRooms(sideChatRoomLimit + sideChatRoomAddPerLoad)" ></side-chat-navigation>

        <side-chat-room-selection v-else ref="sideChatRoomSelection" @createChatRoom="createChatRoom" :usersChatRoomIds="usersChatRoomIds" ></side-chat-room-selection>
      </section>
    </div>
    
    <!-- Chat Screen -->
    <div class="transition-all w-9/12 lg:w-6/12" :class="availableMainChatWidth" >
      <main-chat  v-if="currentOpenedChatRoom.id" :chatRoom="currentOpenedChatRoom" :currentUsersData="currentUsersData" :chatMessages="chatMessages[currentOpenedChatRoom.id]" :chatMembers="chatMembers[currentOpenedChatRoom.id]" :costumizedUsersData="costumizedUsersData" :blankIcon="blankIcon" @errorIcon="(key)=>setChatRoomErrorIcon(key,true)" :mainChatRoomLimit="mainChatRoom.info[currentOpenedChatRoom.id].limit" :mainChatRoomAddPerLoad="mainChatRoomAddPerLoad" @setMemberIconToBlank="(memberId)=>{setMemberIconToBlank(memberId)}" @setCurrentChatRoom="(chatRoomId)=>{setCurrentChatRoom(chatRoomId)}" @leaveChatRoom="(chatId)=>{leaveChatRoom(chatId)}" @toggleUserInfoTab="(toOpen,costumData,originalData)=>{$refs.userInfo.toggleTab(toOpen,costumData,originalData)}" @setChatRoomInfo="(chatRoom,key,isMember)=>{ setChatRoomInfo(chatRoom,key,isMember)}" @topScrolled="watchMessages(currentOpenedChatRoom.id,mainChatRoom.info[currentOpenedChatRoom.id].limit + mainChatRoom.addPerLoad )"  class="hidden md:block" ></main-chat>

      <chat-room-selection ref="chatRoomSelection" v-if="!hasChatRoom" :usersChatRoomIds="usersChatRoomIds" :allChatRoom="allChatRoom" @errorIcon="(key)=>setChatRoomErrorIcon(key)" @joinChatRoom="(key)=>{joinChatRoom(key)}" @setChatRoomInfo="(chatRoom,key)=>{ setChatRoomInfo(chatRoom,key)}" @bottomScrolled="getAllChatRooms(discoverChatRoomLimit + discoverChatRoomAddPerLoad)" class="hidden sm:block  col-span-12 sm:col-span-4  md:col-span-8 lg:col-span-9"></chat-room-selection>

    </div>

    <!-- Discover chat -->
    <discover-chat-navigation v-if="hasChatRoom" :recommendedChatRoom="allChatRoom" :isDiscoverExpanded="isDiscoverExpanded" :isAtLargeScreen="isAtLargeScreen" :usersChatRoomIds="usersChatRoomIds" :isAddingDiscoverChatRoom="isAddingDiscoverChatRoom"  class="h-full transition-all absolute lg:static" :isDiscoverChatRoomReachedLimit="isDiscoverChatRoomReachedLimit" :currentUsersData="currentUsersData" :costumizedUsersData="costumizedUsersData" @toggleIsDiscoverExpanded="toggleIsDiscoverExpanded"  @errorIcon="(key)=>setChatRoomErrorIcon(key)" @joinChatRoom="(key)=>{joinChatRoom(key)}" @setChatRoomInfo="(chatRoom,key)=>{ setChatRoomInfo(chatRoom,key)}" @bottomScrolled="getAllChatRooms(discoverChatRoomLimit + discoverChatRoomAddPerLoad)"  :class="[isDiscoverExpanded ? 'lg:w-3/12' : '', 'w-0']"></discover-chat-navigation>

  </section>
</div>

<div v-else class="h-screen">
  <main class="relative overflow-hidden" style="height: 92vh">

    <div class="flex overflow-auto" style="width: 200%;">

    <transition name="slide-nav-target">
    <section v-if="!isDiscoverExpanded" class="w-1/2" style="padding: 1%">

      <div class="flex flex-col" :class="[currentOpenedChatRoom.id ? 'hidden' : '', '']" >
        <top-navigation style="height: 10vh;margin-bottom: 1vh" :isAsideExpanded="isAsideExpanded" class="flex-shrink-0"  :costumizedUsersData="costumizedUsersData" @toggleUserInfoTab="(toOpen)=>{$refs.userInfo.toggleTab(toOpen,costumizedUsersData,currentUsersData)}" @signOut="signOut" ref="topNavigation"></top-navigation>

        <div style="height: 79vh">
        <side-chat-navigation v-if="hasChatRoom" ref="sideChatNavigation" :usersChatRoom="usersChatRoom" :isAsideExpanded="isAsideExpanded" :currentOpenedChatRoom="currentOpenedChatRoom" :currentUsersData="currentUsersData" :isAtLargeScreen="isAtLargeScreen" :previousOpenedChatId="previousOpenedChatId" :maxChatRooms="maxChatRooms" :isAddingSideChatRoom="isAddingSideChatRoom" :sideChatRoomLimit="sideChatRoomLimit" :chatRoomsId="costumizedUsersData.chatRoomsId"  @errorIcon="(key)=>setChatRoomErrorIcon(key)" @toggleIsAsideExpanded="toggleIsAsideExpanded" @setCurrentChatRoom="(chatRoomId)=>setCurrentChatRoom(chatRoomId)" @createChatRoom="createChatRoom" @bottomScrolled="watchUsersChatRooms(sideChatRoomLimit + sideChatRoomAddPerLoad)" ></side-chat-navigation>

        <side-chat-room-selection v-else ref="sideChatRoomSelection" @createChatRoom="createChatRoom" @toggleIsDiscoverExpanded="(toOpen)=>{toggleIsDiscoverExpanded(toOpen)}" ></side-chat-room-selection>
        </div>
      </div>

      <div v-if="currentOpenedChatRoom.id" style="height: 89vh">
        <!-- Chat Screen -->
        <main-chat  v-if="hasChatRoom" :chatRoom="currentOpenedChatRoom" :currentUsersData="currentUsersData" :chatMessages="chatMessages[currentOpenedChatRoom.id]" :chatMembers="chatMembers[currentOpenedChatRoom.id]" :costumizedUsersData="costumizedUsersData" :blankIcon="blankIcon" @errorIcon="(key)=>setChatRoomErrorIcon(key,true)" :mainChatRoomLimit="mainChatRoom.info[currentOpenedChatRoom.id].limit" :mainChatRoomAddPerLoad="mainChatRoomAddPerLoad" @setMemberIconToBlank="(memberId)=>{setMemberIconToBlank(memberId)}" @setCurrentChatRoom="(chatRoomId)=>{setCurrentChatRoom(chatRoomId)}" @leaveChatRoom="(chatId)=>{leaveChatRoom(chatId)}" @toggleUserInfoTab="(toOpen,costumData,originalData)=>{$refs.userInfo.toggleTab(toOpen,costumData,originalData)}" @setChatRoomInfo="(chatRoom,key,isMember)=>{ setChatRoomInfo(chatRoom,key,isMember)}" @topScrolled="watchMessages(currentOpenedChatRoom.id,mainChatRoom.info[currentOpenedChatRoom.id].limit + mainChatRoom.addPerLoad )"></main-chat>
        
      </div>

    </section>
    </transition>
       
    <section v-if="isDiscoverExpanded" class="w-1/2" style="padding: 1%">
      <!-- Discover chat -->
      <discover-chat-navigation class="h-full rounded-xl transition-all absolute lg:relative" style="height: 89vh" v-if="hasChatRoom" :recommendedChatRoom="allChatRoom" :isDiscoverExpanded="isDiscoverExpanded" :isAtLargeScreen="isAtLargeScreen" :usersChatRoomIds="usersChatRoomIds" :isAddingDiscoverChatRoom="isAddingDiscoverChatRoom"  :isDiscoverChatRoomReachedLimit="isDiscoverChatRoomReachedLimit" :currentUsersData="currentUsersData" :costumizedUsersData="costumizedUsersData" @toggleIsDiscoverExpanded="toggleIsDiscoverExpanded"  @errorIcon="(key)=>setChatRoomErrorIcon(key)" @joinChatRoom="(key)=>{joinChatRoom(key)}" @setChatRoomInfo="(chatRoom,key)=>{ setChatRoomInfo(chatRoom,key)}" @bottomScrolled="getAllChatRooms(discoverChatRoomLimit + discoverChatRoomAddPerLoad)"  ></discover-chat-navigation>

      <chat-room-selection style="height: 89vh" ref="chatRoomSelection" v-if="!hasChatRoom" :usersChatRoomIds="usersChatRoomIds" :allChatRoom="allChatRoom" @errorIcon="(key)=>setChatRoomErrorIcon(key)" @joinChatRoom="(key)=>{joinChatRoom(key)}" @setChatRoomInfo="(chatRoom,key)=>{ setChatRoomInfo(chatRoom,key)}" @bottomScrolled="getAllChatRooms(discoverChatRoomLimit + discoverChatRoomAddPerLoad)" ></chat-room-selection>

    </section>
     
    </div>

  </main>
  <nav style="height: 8vh">

    <div class="w-full flex" >
      <transition name="slide-nav-target">
        <div v-if="isDiscoverExpanded" class="transition-all bg-transparent w-1/2 h-0.5"></div>
      </transition>
      <div   class="transition-all bg-purple-600 w-1/2 h-0.5"></div>

    </div>
    <div class="grid grid-cols-2 text-2xl overflow-hidden">
      <div  @click="toggleIsDiscoverExpanded(false)" class="flex justify-center pop-click bg-white hover:bg-purple-100 transition-all py-4 text-lg" :class="[!isDiscoverExpanded ? 'text-purple-500' : '', 'text-gray-400']">
        <ion-icon class="mx-auto" name="chatbubble"></ion-icon>
      </div>

      <div @click="toggleIsDiscoverExpanded(true)" class="flex justify-center pop-click bg-white hover:bg-purple-100 transition-all py-4 text-lg" :class="[isDiscoverExpanded ? 'text-purple-500' : '', 'text-gray-400']">
          <ion-icon class="mx-auto" name="apps"></ion-icon>
      </div>
    </div>

  </nav>
</div>

<user-info ref="userInfo" :loggedInUsersChatRoomIds="usersChatRoomIds" @joinChatRoom="(key)=>{joinChatRoom(key)}" @setChatRoomInfo="(chatRoom,key,isAlreadyMember)=>{ setChatRoomInfo(chatRoom,key,isAlreadyMember)}" @errorIcon="(key)=>setChatRoomErrorIcon(key)" @signOut="signOut" @deleteAccountModal="(toOpen,callback)=>{$refs.deleteAccountModal.willOpenAlert(toOpen,callback)}"></user-info> 

<chat-room-info ref="chatRoomInfo" @joinChatRoom="(chatRoomId)=>{joinChatRoom(chatRoomId)}" ></chat-room-info>
<alert-modal ref="leaveModal" class="z-50" title="Are you sure you want to leave the Chat Room?" okButtonText="Leave Chat Room" iconName="leave-chat.svg" alertColor="bg-pink-700" okButtonClass="border-pink-600 bg-pink-700 active:bg-pink-700" ></alert-modal>

<alert-modal ref="deleteAccountModal" class="z-50" title="Are you sure you want to delete your account?" body="This is a permanent action!" okButtonText="Delete Account" iconName="security.svg" alertColor="bg-pink-700" okButtonClass="border-pink-600 bg-pink-700 active:bg-pink-700" ></alert-modal>

<create-chat-room ref="createChatRoom" :creatorId="currentUsersData.uid" :costumizedUsersData="costumizedUsersData" @notification="(status,message)=>{$refs.notification.startToast(status,message)}"></create-chat-room>
<notification ref="notification"></notification>

</template>

<script>
import MainChat from '@/components/MainChat.vue';
import SideChatRoomSelection from '@/components/SideChatRoomSelection.vue';
import TopNavigation from '@/components/TopNavigation.vue';
import SideChatNavigation from '@/components/SideChatNavigation.vue';
import DiscoverChatNavigation from '@/components/DiscoverChatNavigation.vue';
import ChatRoomSelection from '@/components/ChatRoomSelection.vue';
import ChatRoomInfo from "@/components/ChatRoomInfo.vue";
import AlertModal from "@/components/AlertModal.vue";
import CreateChatRoom from '@/components/CreateChatRoom.vue';
import UserInfo from '@/components/UserInfo.vue';
import Notification from '@/components/Notification.vue';


import firebase from "firebase/app";

export default {
  components : {
    'user-info' : UserInfo,
    'top-navigation' : TopNavigation,
    'side-chat-navigation' : SideChatNavigation,
    'discover-chat-navigation' : DiscoverChatNavigation,
    'chat-room-selection' : ChatRoomSelection,
    'main-chat' : MainChat,
    'side-chat-room-selection' : SideChatRoomSelection,
    'chat-room-info' : ChatRoomInfo,
    'alert-modal' : AlertModal,
    'create-chat-room' : CreateChatRoom,
    'notification' : Notification
  },
  name: 'Home',
  data(){
    return {
      isTargetingChatRoom : false,
      discoverChatRoomAddPerLoad : 15,
      discoverChatRoomLimit : 15,
      mainChatRoom : {
        addPerLoad : 30,
        info : {} //storage of limit and isAdding attribute of each chat room
      },
      isAddingDiscoverChatRoom : false,
      isDiscoverChatRoomReachedLimit : false,
      sideChatRoomAddPerLoad : 10,
      sideChatRoomLimit : 10,
      isAddingSideChatRoom : false,
      allChatRoom : {},
      blankIcon : "/profile-icons/blank.png",
      costumizedUsersData : {},
      usersChatRoom : {},
      currentOpenedChatRoom : {},
      chatMessages : {},
      chatMembers : {},
      isAtLargeScreen : false,
      previousOpenedChatId : '0',
      usersChatRoomIds : null,
      prevRecomendedJoinedChatRoomCount : 0
    }
  },
  props : {
    currentUsersData : Object
  },
  mounted (){
    this.previousOpenedChatId =  localStorage.getItem("previousOpenedChatId") || '0';
    this.getUsersCostumizedInfo(),
    this.watchUsersChatRooms(this.sideChatRoomLimit),
    this.getAllChatRooms(this.discoverChatRoomLimit),
    this.checkScreenSize(),
    window.scrollTo(0,document.body.scrollHeight),
    this.watchUsersChatRoomsId()
    
  },
  beforeUpdate(){
    localStorage.setItem("previousOpenedChatId", this.currentOpenedChatRoom.id),
    localStorage.setItem("previousIsDiscoverExpanded", this.isDiscoverExpanded ? '1' : '0'),
    localStorage.setItem("previousIsAsideExpanded", this.isAsideExpanded ? '1' : '0')
  },
  methods : {
    getInvitation(){
      const inviteKey = "inviteId";
      const inviteId = localStorage.getItem(inviteKey);
      if(inviteId){
        firebase.database().ref("chatRooms").child(inviteId).get().then( (snapshot)=>{
          if(snapshot.exists()){
            var isAlreadyMember = false;
            if(this.costumizedUsersData.chatRoomsId[inviteId]){
              isAlreadyMember = true;
            }
            this.setChatRoomInfo(snapshot.val(),inviteId,isAlreadyMember);
            localStorage.removeItem(inviteKey);
          }else{
            localStorage.removeItem(inviteKey);
          }
        });
      }
      this.setChatRoomInfo();
    },
    test(){
      for(const key in this.allChatRoom){
        const roomRef = firebase.database().ref('chatRooms');
        const newKey = roomRef.push().key;
        roomRef.child(newKey).set(this.allChatRoom[key]);
      }
     
    },
    signOut(){
      firebase.auth().signOut().then(()=> {
         this.$router.push({path:'/sign-in'});
      }, function(error) {
        console.error('Sign Out Error', error);
      });
    },
    createChatRoom(){
      this.$refs.createChatRoom.toggleTab(true);
    },
    leaveChatRoom(chatRoomId){
      if(!chatRoomId)return;
      const leaveCallBack = () => {
        const messageRef = firebase.database().ref('chatMessages');
        const leaveMessageKey = messageRef.push().key;
        const leaveDate = Date.now();
        const leaveMessage = {
          date : leaveDate,
          isFromSystem : true,
          message : this.costumizedUsersData.username + " left the chat room.",
          senderId : this.currentUsersData.uid
        }

        const leaveRoomRecent = {
          date : leaveDate,
          message : ' left the chat room.',
          sender : {
            id : this.currentUsersData.uid,
            username : this.costumizedUsersData.username
          }
        };

        messageRef.child(leaveMessageKey).set(leaveMessage, (error) => {
          if (error) {
            console.log(error);
            this.$refs.notification.startToast('danger','There was a problem leaving the chat room. Please try again.');
          } else {
            const roomRef = firebase.database().ref('chatRooms').child(chatRoomId);
            roomRef.child('recent').set(leaveRoomRecent);
            roomRef.child('messagesIds').child(leaveMessageKey).set(leaveDate);
            let userId = this.currentUsersData.uid; 
            const userChatRoomRef = firebase.database().ref("users").child(userId + '/chatRoomsId');
            userChatRoomRef.child(chatRoomId).remove().then( ()=>{
              firebase.database().ref("chatRooms").child(chatRoomId).child("membersId").child(userId).remove();
              this.$refs.notification.startToast('info','You successfully left the chat room.');
              if(this.isAtLargeScreen && this.maxChatRooms > 0){   
                this.$refs.sideChatNavigation.setCurrentChatRoomToMostRecent(true);
              }else{
                this.setCurrentChatRoom(null);
              }
            } );
          }
        });

      };
      this.$refs.leaveModal.willOpenAlert(true,leaveCallBack);
    },
    setMemberIconToBlank(){
      //test
    },
    setChatRoomInfo(chatRoom,key,isAlreadyMember){
      this.$refs.chatRoomInfo.setChatRoomInfo(chatRoom,key,isAlreadyMember);
    },
    toggleIsDiscoverExpanded(toOpen = null){
      if(toOpen === null)toOpen = !this.isDiscoverExpanded;
      this.$router.push({ name : 'Home', params: { chatId: this.currentOpenedChatRoom.id || '-1' , isAsideExpanded : this.isAsideExpanded ? 1 : 0 , isDiscoverExpanded : toOpen ? 1 : 0 } });
    },
    toggleIsAsideExpanded(toOpen = null){
      if(toOpen === null)toOpen = !this.isAsideExpanded;
      this.$router.push({ name: 'Home', params: { chatId: this.currentOpenedChatRoom.id, isAsideExpanded : toOpen ? 1 : 0 , isDiscoverExpanded : this.isDiscoverExpanded ? 1 : 0 } })
    },
    checkScreenSize(){
      this.isAtLargeScreen = window.innerWidth >= 768;
      window.addEventListener("resize", ()=>{
        var isAtLargeScreen = window.innerWidth >= 768;
        this.isAtLargeScreen = isAtLargeScreen;
      });
    },
    joinChatRoom(chatRoomId = null){
      if(!chatRoomId)return;
      const prevHasChatRoom = this.hasChatRoom;
      
       firebase.database().ref().child("chatRooms/" + chatRoomId + "/membersId/" + this.currentUsersData.uid).set(true, (error) => {
          if(!error){
            //add joined message 
            const messageRef = firebase.database().ref('chatMessages');
            const joinMessageKey = messageRef.push().key;
            const joinDate = Date.now();
            const joinMessage = {
              date : joinDate,
              isFromSystem : true,
              message : this.costumizedUsersData.username + " joined the chat room.",
              senderId : this.currentUsersData.uid
            }

            const joinRoomRecent = {
              date : joinDate,
              message : ' joined the chat room.',
              sender : {
                id : this.currentUsersData.uid,
                username : this.costumizedUsersData.username
              }
            };

            messageRef.child(joinMessageKey).set(joinMessage, (error) => {
              if (error) {
                console.log(error);
                this.$refs.notification.startToast('danger','There was a problem joining chat room. Please try again.');
              } else {
                const roomRef = firebase.database().ref('chatRooms').child(chatRoomId);
                roomRef.child('messagesIds').child(joinMessageKey).set(joinDate);
                roomRef.child('recent').set(joinRoomRecent, (error) => {
                  if(error){
                    console.log(error);
                  }else{
                    firebase.database().ref('users').child(this.currentUsersData.uid + "/chatRoomsId/" + chatRoomId).set(joinDate);
                  }
                });
                this.$refs.chatRoomInfo.toggleTab(false);
                if(!prevHasChatRoom && !this.isAtLargeScreen)this.toggleIsDiscoverExpanded(false);

                this.$refs.notification.startToast('success','You successfully joined the chat room.');
                delete this.allChatRoom[chatRoomId];
              }
            });

          }else {
            this.$refs.notification.startToast('danger','There was a problem joining chat room. Please try again.');
          }
        });

      
    },
    setChatRoomErrorIcon(key, isOnCurrentChat = false){
      if(isOnCurrentChat)this.currentOpenedChatRoom.icon = this.blankIcon;
      if(this.usersChatRoom[key])return this.usersChatRoom[key].icon = this.blankIcon;
      if(this.allChatRoom[key])return this.allChatRoom[key].icon = this.blankIcon;
    },  
    getAllChatRooms(limit = 10){
      if(this.isAddingDiscoverChatRoom)return;
      this.isAddingDiscoverChatRoom = true;
      this.discoverChatRoomLimit = limit;
      // if(this.hasChatRoom)return;
      const roomRef = firebase.database().ref("chatRooms").limitToLast(limit);
      roomRef.get().then((snapshot) => {
        if (snapshot.exists()) {
          let recomendedJoinedChatRoomCount = 0;
          const chatRooms = snapshot.val();
          for(var key in chatRooms){
            if(this.usersChatRoomIds.includes(key)){
              recomendedJoinedChatRoomCount++;
              continue;
            }
            chatRooms[key].id = key;
            this.allChatRoom[key] = chatRooms[key];
          }
          this.isAddingDiscoverChatRoom = false;
          if(this.discoverChatRoomLimit === Object.keys(snapshot.val()).length)this.isDiscoverChatRoomReachedLimit = true;

          const totalJoined = recomendedJoinedChatRoomCount + this.prevRecomendedJoinedChatRoomCount;
          if(recomendedJoinedChatRoomCount > 0){
            const newChatRoomLimit = recomendedJoinedChatRoomCount * 2;
            if(totalJoined <= this.usersChatRoomIds.length){
              this.getAllChatRooms(newChatRoomLimit);
            }
          }
          
          this.prevRecomendedJoinedChatRoomCount = recomendedJoinedChatRoomCount;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    getUsersCostumizedInfo(){
      const userRef = firebase.database().ref().child("users/" + this.currentUsersData.uid);
      // const usersChatRooms = this.currentUsersData.chatRoomsId;
      userRef.on("value",(snapshot) => {
        if (snapshot.exists()) {
          let costumizedUserData = snapshot.val();
          costumizedUserData.uid = snapshot.key;
          costumizedUserData.uid = snapshot.key;
          this.costumizedUsersData = costumizedUserData;
          this.getInvitation();
        }
      })
    },
    setCurrentChatRoom(chatRoomId = null){
      if(!chatRoomId){
        this.$router.push({ name : 'Home', params: { chatId: '0', isAsideExpanded : this.isAsideExpanded ? 1 : 0 , isDiscoverExpanded : this.isDiscoverExpanded ? 1 : 0 } });
        return;
      }
      if(!this.mainChatRoom.info[chatRoomId])this.mainChatRoom.info[chatRoomId] = {
        limit : this.mainChatRoom.addPerLoad,
        isAdding : false
      };
      
      if(this.isTargetingChatRoom)return;
      if(this.currentOpenedChatRoom.id === chatRoomId)return;
      this.isTargetingChatRoom = true;

      const roomRef = firebase.database().ref().child("chatRooms/" + chatRoomId);
      roomRef.child('name').get().then((snapshot) => {
        if (snapshot.exists()) {
          this.watchMessages(chatRoomId,this.mainChatRoom.info[chatRoomId].limit);
          const chatRoomName = snapshot.val();
          this.currentOpenedChatRoom.name = chatRoomName;
          this.currentOpenedChatRoom.id = chatRoomId;
          this.watchChatMembers(chatRoomId);
          this.$router.push({ name : 'Home', params: { chatId: chatRoomId, isAsideExpanded : this.isAsideExpanded ? 1 : 0 , isDiscoverExpanded : this.isDiscoverExpanded ? 1 : 0 } });
          roomRef.child('messagesIds').on("value", (snapshot)=> {
            this.currentOpenedChatRoom.maxChatMessages = snapshot.numChildren();
          })
          roomRef.child('creatorId').once('value').then((snapshot) => {
            this.currentOpenedChatRoom.creatorId = snapshot.val();
          });
          roomRef.child('icon').once('value').then((snapshot) => {
            this.currentOpenedChatRoom.icon = snapshot.val();
          });
          roomRef.child('description').once('value').then((snapshot) => {
            this.currentOpenedChatRoom.description = snapshot.val();
          });
          this.isTargetingChatRoom = false;
        }else{
           this.currentOpenedChatRoom = {};
           this.isTargetingChatRoom = false;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    getUsersChatRooms(chatRoomId,isNewMember){
      const roomRef = firebase.database().ref().child("chatRooms/" + chatRoomId);

      roomRef.child('name').get().then((snapshot) => {
        if (snapshot.exists()) {
          let chatRoomName = snapshot.val();
          this.usersChatRoom[chatRoomId] = {};
          this.usersChatRoom[chatRoomId].name = chatRoomName;
          this.usersChatRoom[chatRoomId].id = chatRoomId;
          this.usersChatRoom[chatRoomId].isCurrentUserNewMember = isNewMember;

          this.watchChatRoomChange(chatRoomId); //watch recent message change and chat room name change

          roomRef.child('icon').get().then((snapshot) => {
            this.usersChatRoom[chatRoomId].icon = snapshot.val(); 
          });

          roomRef.child('recent').get().then((snapshot) => {
            this.usersChatRoom[chatRoomId].recent = snapshot.val(); 
            this.usersChatRoom[chatRoomId].recent.dateGapFromNow = this.toDateGap(snapshot.val().date);
          });

        }
      }).catch((error) => {
        console.error(error);
      });
    },
    watchUsersChatRoomsId(){
      let allRoomRef = firebase.database().ref('users/' + this.currentUsersData.uid + '/chatRoomsId').orderByValue();
      
      allRoomRef.on("value", (snapshot) => {
        if(snapshot.val())return this.usersChatRoomIds = Object.keys(snapshot.val());
        this.usersChatRoomIds = [];

      });
    },
    watchUsersChatRooms(limit = 10){
      if(this.isAddingSideChatRoom)return;
      this.isAddingSideChatRoom = true;
      this.sideChatRoomLimit = limit;
      var roomRef = firebase.database().ref('users/' + this.currentUsersData.uid + '/chatRoomsId').orderByValue().limitToLast(limit);
      
      roomRef.on("child_added", (snapshot) => {
        this.getUsersChatRooms(snapshot.key,snapshot.val());
      });
      roomRef.on("child_removed", (snapshot) => {
        delete this.usersChatRoom[snapshot.key];
        
        if(this.costumizedUsersData.chatRoomsId[snapshot.key])delete this.costumizedUsersData.chatRoomsId[snapshot.key];
      });
      this.isAddingSideChatRoom = false;
    },
    watchMessages(chatRoomId,limit){
      const currentChatRoom = this.mainChatRoom.info[chatRoomId];
      if(!currentChatRoom)return;
      if(currentChatRoom.isAdding)return;
      currentChatRoom.isAdding = true;

      if(!this.chatMessages[chatRoomId])this.chatMessages[chatRoomId] = {};
      var ref = firebase.database().ref('chatRooms/' + chatRoomId + '/messagesIds').orderByValue().limitToLast(limit);
      currentChatRoom.limit = limit;
      ref.on("child_added", (snapshot) => {
        this.getMessages(snapshot.key,chatRoomId);
      });
      currentChatRoom.isAdding = false;
    },
    getMessages(messageId,chatRoomId){
      const roomRef = firebase.database().ref().child("chatMessages").child(messageId);
      roomRef.get().then((snapshot) => {
        if (snapshot.exists()) {
          let message = snapshot.val();
          message.id = snapshot.key;
          message.dateGapFromNow = this.toDateGap(message.date);
          
          this.chatMessages[chatRoomId][snapshot.key] = message;
          // this.chatMessages[chatRoomId].push(message);
          if(Object.keys(this.chatMessages[chatRoomId]).length === this.mainChatRoomLimit) this.isAddingMainChatRoom = false;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    watchChatMembers(chatRoomId){
      if(this.chatMembers[chatRoomId] !== undefined)return; //chat message watcher was already attached
      this.chatMembers[chatRoomId] = {};
      var ref = firebase.database().ref('chatRooms/' + chatRoomId + '/membersId');
      ref.on("child_added", (snapshot) => {
        this.getChatMembers(snapshot.key,chatRoomId);
      });
    },
    getChatMembers(memberId,chatRoomId){
      const roomRef = firebase.database().ref().child("users").child(memberId);
      roomRef.get().then((snapshot) => {
        if (snapshot.exists()) {
          let member = snapshot.val();
          this.chatMembers[chatRoomId][snapshot.key] = member;
        }
      }).catch((error) => {
        console.error(error);
      });
    },
    watchChatRoomChange(chatRoomId){
      //watch chat room change of recent messages and name
      const roomRecentRef = firebase.database().ref().child("chatRooms/" + chatRoomId + '/recent');
      
      roomRecentRef.on('child_changed', (newSnapshot) => {
        if(this.$refs.sideChatNavigation)this.$refs.sideChatNavigation.triggerNotif(chatRoomId);
        
        if(newSnapshot.key === 'date'){
          const newDate = newSnapshot.val();
          this.usersChatRoom[chatRoomId].recent.dateGapFromNow = this.toDateGap(newDate);
        }
        this.usersChatRoom[chatRoomId].recent[newSnapshot.key] = newSnapshot.val();
      });
      const roomNameRef = firebase.database().ref().child("chatRooms/" + chatRoomId + '/name');
      roomNameRef.on('value', (newSnapshot) => {
        this.usersChatRoom[chatRoomId].name = newSnapshot.val();
        // this.$refs.sideChatNavigation.triggerNotif(chatRoomId);
      });
     
    },
    toDateGap(unformatedDate){
      let dateGap  = "";
      if(!unformatedDate)return dateGap;

      const chatDate = new Date(unformatedDate);
      const currentDate = new Date();

      const chatMonth  = chatDate.getMonth();
      const currentMonth  = currentDate.getMonth();
      if(chatMonth !== currentMonth)return chatDate.getMonth() + '/' + chatDate.getDate() + '/' + chatDate.getFullYear();

      const chatDay = chatDate.getDate();
      const currentDay = currentDate.getDate();
      if(currentDay !== chatDay)return currentDay-chatDay + ' d';

      const chatHour = chatDate.getHours();
      const currentHour = currentDate.getHours();
      if(currentHour !== chatHour)return currentHour-chatHour + ' h';

      const chatMinute  = chatDate.getMinutes();
      const currentMinute  = currentDate.getMinutes();
      if(currentMinute !== chatMinute)return currentMinute - chatMinute + ' m';
      
      return "now";

    }
  },
  computed : {
    mainChatRoomAddPerLoad(){
      return this.mainChatRoom.addPerLoad;
    },
    maxChatRooms (){
      if(!this.costumizedUsersData.chatRoomsId)return 0;
      return Object.keys(this.costumizedUsersData.chatRoomsId).length;
    },
    urlParamChatId(){
      return this.$route.params.chatId;
    },
    isDiscoverExpanded(){
      if(this.$route.params.isDiscoverExpanded == 0)return false;
      return true;
    },
    isAsideExpanded(){
      if(this.$route.params.isAsideExpanded == 0)return false;
      return true;
    },
    availableMainChatWidth (){
      return {
      'w-11/12 lg:w-9/12' : !this.isAsideExpanded && this.isDiscoverExpanded || this.isAsideExpanded && !this.isDiscoverExpanded,
      'w-11/12 lg:w-11/12': !this.isAsideExpanded && !this.isDiscoverExpanded || !this.hasChatRoom
      }
    },
    hasChatRoom(){
      if(!this.usersChatRoomIds)return false;
      if(this.usersChatRoomIds.length <= 0)return false;
      return true;
    }
  },
  watch : {
    urlParamChatId: {
      immediate : true,
      handler(chatId){
        this.setCurrentChatRoom(chatId);
      }  
    },
    isAtLargeScreen(isAtLargeScreen){
      if(!this.$refs.sideChatNavigation)return;
      if(isAtLargeScreen && !this.currentOpenedChatRoom.id)this.$refs.sideChatNavigation.setCurrentChatRoomToMostRecent();
    }
  },
  
}  

</script>

<style scoped>

.slide-nav-target-enter-active,
.slide-nav-target-leave-active {
  transition: all 200ms linear;
}

.slide-nav-target-enter-from,
.slide-nav-target-leave-to {
  margin-left: -100vw;
}
</style>
